module.exports = __webpack_public_path__ + "img/clerk_accounting_3.f51f04eb.png";